/* ============================================================
   B2C REORDER PAGE — LOCAL THEME BULLETPROOF CART UPDATE
   ============================================================ */
(function() {
  'use strict';


  const cards = () => document.querySelectorAll('.reorder-item-card');
  const productWrapper = document.getElementById('ReorderProducts');
  const searchInput = document.getElementById('ReorderSearch');
  const searchClear = document.getElementById('ReorderSearchClear');
  const filterSelect = document.getElementById('ReorderFilter');
  const filterToggle = document.getElementById('ReorderFilterToggle');
  const sortSheet = document.getElementById('ReorderSortSheet');
  const sortOverlay = document.getElementById('ReorderSortOverlay');
  const sortClose = document.getElementById('ReorderSortClose');
  const sortOptions = document.querySelectorAll('.reorder-sort-option');
  const pagination = document.getElementById('ReorderPagination');
  const categoryNav = document.getElementById('CategoryNav');
  const categoryButtons = document.querySelectorAll('.reorder-category-link');
  const scrollLeft = document.getElementById('CategoryScrollLeft');
  const scrollRight = document.getElementById('CategoryScrollRight');
  const resultsInfo = document.getElementById('ReorderResultsInfo');


  const PRODUCTS_PER_PAGE = 12;
  let currentPage = 1;
  let activeCategory = 'all';
  let activeSort = 'recent';


  function init() {
    storeOriginalButtonTexts();
    bindSearch();
    bindFilter();
    bindMobileSort();
    bindCategories();
    bindCategoryScroll();
    bindAddToCart();
    bindSearchChips();
    applyFilters();
    syncCartButtons();
  }


  function storeOriginalButtonTexts() {
    document.querySelectorAll('.reorder-add-btn').forEach(function(btn) {
      if (!btn.dataset.originalText) {
        btn.dataset.originalText = btn.querySelector('.reorder-add-btn__text').textContent.trim();
      }
    });
  }


  /* ── SEARCH ── */
 function bindSearch() {


    if (!searchInput) return;


    let debounceTimer;


    searchInput.addEventListener("input", function () {


        clearTimeout(debounceTimer);


        debounceTimer = setTimeout(function () {


            currentPage = 1;
            applyFilters();
            toggleClearButton();


        },200);


    });


    if(searchClear){


        searchClear.addEventListener("click",function(){


            searchInput.value = "";
            currentPage = 1;
            applyFilters();
            toggleClearButton();


        });


    }


    toggleClearButton();


}


  function toggleClearButton() {
    if (!searchClear) return;
    searchInput.value.trim().length > 0
      ? searchClear.removeAttribute('hidden')
      : searchClear.setAttribute('hidden', '');
  }


  /* ── SEARCH CHIPS ── */
  function bindSearchChips() {
    document.querySelectorAll('.search-chip').forEach(function(chip) {
      chip.addEventListener('click', function() {
        const isActive = this.classList.contains('is-active');
        if (isActive) {
          searchInput.value = '';
          document.querySelectorAll('.search-chip').forEach(function(c) { c.classList.remove('is-active'); });
        } else {
          searchInput.value = this.dataset.search;
          document.querySelectorAll('.search-chip').forEach(function(c) { c.classList.remove('is-active'); });
          this.classList.add('is-active');
        }
        currentPage = 1;
        applyFilters();
        toggleClearButton();
      });
    });


    searchInput.addEventListener('input', function() {
      if (searchInput.value.trim() === '') {
        document.querySelectorAll('.search-chip').forEach(function(c) { c.classList.remove('is-active'); });
      } else {
        const val = searchInput.value.trim().toLowerCase();
        document.querySelectorAll('.search-chip').forEach(function(c) {
          c.classList.toggle('is-active', c.dataset.search === val);
        });
      }
    });
  }


  /* ── DESKTOP FILTER ── */
  function bindFilter() {
    if (!filterSelect) return;
    filterSelect.addEventListener('change', function() {
      activeSort = this.value;
      currentPage = 1;
      applyFilters();
      document.querySelectorAll('.reorder-sort-option').forEach(function(opt) {
        opt.classList.toggle('active', opt.dataset.sort === activeSort);
      });
    });
  }


  /* ── MOBILE SORT BOTTOM SHEET ── */
  function bindMobileSort() {
    if (!filterToggle || !sortSheet) return;


    filterToggle.addEventListener('click', function() {
      sortSheet.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    });


    function closeSheet() {
      sortSheet.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }


    if (sortOverlay) sortOverlay.addEventListener('click', closeSheet);
    if (sortClose) sortClose.addEventListener('click', closeSheet);


    sortOptions.forEach(function(opt) {
      opt.addEventListener('click', function() {
        activeSort = this.dataset.sort;
        currentPage = 1;
        applyFilters();
        if (filterSelect) filterSelect.value = activeSort;
        closeSheet();
      });
    });
  }


  /* ── CATEGORIES ── */
  function bindCategories() {
    categoryButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        categoryButtons.forEach(function(b) { b.classList.remove('active'); });
        this.classList.add('active');
        activeCategory = this.dataset.category;
        currentPage = 1;
        applyFilters();
        this.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    });
  }


  /* ── CATEGORY SCROLL INDICATORS ── */
  function bindCategoryScroll() {
    if (!categoryNav) return;


    function updateScrollIndicators() {
      if (window.innerWidth > 749) {
        if (scrollLeft) scrollLeft.setAttribute('hidden', '');
        if (scrollRight) scrollRight.setAttribute('hidden', '');
        return;
      }
      const canScrollLeft = categoryNav.scrollLeft > 4;
      const canScrollRight = categoryNav.scrollLeft < (categoryNav.scrollWidth - categoryNav.clientWidth - 4);


      if (scrollLeft) {
        canScrollLeft ? scrollLeft.removeAttribute('hidden') : scrollLeft.setAttribute('hidden', '');
      }
      if (scrollRight) {
        canScrollRight ? scrollRight.removeAttribute('hidden') : scrollRight.setAttribute('hidden', '');
      }
    }


    categoryNav.addEventListener('scroll', updateScrollIndicators, { passive: true });
    window.addEventListener('resize', updateScrollIndicators);


    if (scrollLeft) scrollLeft.addEventListener('click', function() {
      categoryNav.scrollBy({ left: -200, behavior: 'smooth' });
    });
    if (scrollRight) scrollRight.addEventListener('click', function() {
      categoryNav.scrollBy({ left: 200, behavior: 'smooth' });
    });


    updateScrollIndicators();
  }


  /* ── APPLY FILTERS ── */
  function applyFilters() {
    const searchValue = searchInput ? searchInput.value.toLowerCase().trim() : '';
    const allCards = Array.from(cards());


    const visible = allCards.filter(function(card) {
      let show = true;


      if (searchValue) {
        const haystack = [
          card.dataset.title || '',
          card.dataset.sku || '',
          card.dataset.category || '',
          card.dataset.collections || ''
        ].join(' ');
        if (!haystack.includes(searchValue)) show = false;
      }


      if (activeCategory !== 'all' && card.dataset.category !== activeCategory) {
        show = false;
      }


      return show;
    });


    if (activeSort === 'recent') {
      visible.sort(function(a, b) {
        return (parseInt(b.dataset.lastOrder) || 0) - (parseInt(a.dataset.lastOrder) || 0);
      });
    } else if (activeSort === 'most-ordered') {
      visible.sort(function(a, b) {
        return (parseInt(b.dataset.qty) || 0) - (parseInt(a.dataset.qty) || 0);
      });
    }


    visible.forEach(function(card) {
      card.classList.remove('pagination-hidden');
      if(productWrapper){
    productWrapper.appendChild(card);
}
    });
    allCards.forEach(function(card) {
      if (!visible.includes(card)) {
        card.classList.add('pagination-hidden');
      } else {
        card.classList.remove('pagination-hidden');
      }
    });


    applyPagination(visible);
  }


  function applyPagination(filteredCards) {
    const allCards = Array.from(cards());
    const totalPages = Math.ceil(filteredCards.length / PRODUCTS_PER_PAGE) || 1;
    if (currentPage > totalPages) currentPage = 1;


    const start = (currentPage - 1) * PRODUCTS_PER_PAGE;
    const end = start + PRODUCTS_PER_PAGE;


    allCards.forEach(function(card) { card.style.display = 'none'; });
    filteredCards.forEach(function(card, index) {
      if (index >= start && index < end) card.style.display = '';
    });


    if (resultsInfo) {
      const showing = Math.min(end, filteredCards.length);
      resultsInfo.textContent = 'Showing ' + (start + 1) + '–' + showing + ' of ' + filteredCards.length + ' products';
    }


    renderPagination(totalPages);
  }


  function renderPagination(totalPages) {
    if (!pagination) return;
    pagination.innerHTML = '';
    if (totalPages <= 1) return;


    if (currentPage > 1) {
      const prev = document.createElement('button');
      prev.innerHTML = '←';
      prev.setAttribute('aria-label', 'Previous page');
      prev.addEventListener('click', function() {
        currentPage--;
        applyFilters();
        productWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      pagination.appendChild(prev);
    }


    const maxButtons = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxButtons / 2));
    let endPage = Math.min(totalPages, startPage + maxButtons - 1);
    if (endPage - startPage < maxButtons - 1) {
      startPage = Math.max(1, endPage - maxButtons + 1);
    }


    if (startPage > 1) {
      pagination.appendChild(createPageButton(1));
      if (startPage > 2) {
        const ellipsis = document.createElement('span');
        ellipsis.textContent = '…';
        ellipsis.style.cssText = 'padding:0 4px;color:#999;';
        pagination.appendChild(ellipsis);
      }
    }


    for (let i = startPage; i <= endPage; i++) {
      pagination.appendChild(createPageButton(i));
    }


    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        const ellipsis = document.createElement('span');
        ellipsis.textContent = '…';
        ellipsis.style.cssText = 'padding:0 4px;color:#999;';
        pagination.appendChild(ellipsis);
      }
      pagination.appendChild(createPageButton(totalPages));
    }


    if (currentPage < totalPages) {
      const next = document.createElement('button');
      next.innerHTML = '→';
      next.setAttribute('aria-label', 'Next page');
      next.addEventListener('click', function() {
        currentPage++;
        applyFilters();
        productWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      pagination.appendChild(next);
    }
  }


  function createPageButton(pageNum) {
    const btn = document.createElement('button');
    btn.textContent = pageNum;
    if (pageNum === currentPage) btn.classList.add('active');
    btn.setAttribute('aria-label', 'Page ' + pageNum);
    btn.addEventListener('click', function() {
      currentPage = pageNum;
      applyFilters();
      productWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    return btn;
  }


  /* ═══════════════════════════════════════════════════════════
     CART DRAWER UPDATE — LOCAL / DAWN THEME BULLETPROOF
     ═══════════════════════════════════════════════════════════ */




  /* ─────────────────────────────────────────────
   ADD TO CART
───────────────────────────────────────────── */
function bindAddToCart() {


  document.querySelectorAll('.reorder-item-card').forEach(function(card){


    const addBtn = card.querySelector('.reorder-add-btn');
    const qtyBox = card.querySelector('.reorder-qty-selector');


    if(!addBtn || !qtyBox) return;


    const minusBtn = qtyBox.querySelector('.qty-minus');
    const plusBtn  = qtyBox.querySelector('.qty-plus');
    const qtyValue = qtyBox.querySelector('.reorder-qty-value');


    let quantity = 1;


    /* ---------- ADD BUTTON ---------- */


    addBtn.addEventListener('click', async function(e){


      e.preventDefault();
      e.stopPropagation();


      quantity = 1;
      qtyValue.textContent = quantity;


      addBtn.hidden = true;
      qtyBox.hidden = false;


      await updateCart(addBtn.dataset.variantId, 1);


    });


    /* ---------- PLUS ---------- */
plusBtn.addEventListener('click', async function(){

    quantity++;

    qtyValue.textContent = quantity;

    await changeVariant(
        addBtn.dataset.variantId,
        quantity,
        qtyBox.dataset.cartKey
    );

});


    /* ---------- MINUS ---------- */
minusBtn.addEventListener('click', async function(){

    if(quantity <= 1){

        await removeVariant(qtyBox.dataset.cartKey);

        quantity = 1;

        return;
    }

    quantity--;

    qtyValue.textContent = quantity;

    await changeVariant(
        addBtn.dataset.variantId,
        quantity,
        qtyBox.dataset.cartKey
    );

});

  });


}




/* -------------------------------------------------
   ADD NEW ITEM
-------------------------------------------------- */


async function updateCart(variantId, qty){

    console.log("updateCart()", variantId, qty);

    try{

        const response = await fetch('/cart/add.js',{

            method:'POST',

            headers:{
                'Content-Type':'application/json'
            },

            body:JSON.stringify({

                id:Number(variantId),
                quantity:qty

            })

        });

        if(!response.ok){
            throw new Error("Unable to add product");
        }

        await refreshAjaxCart();

        await syncCartButtons();

        showCartToast("Product added");

    }
    catch(e){

        console.error(e);

    }

}

/* -------------------------------------------------
   CHANGE QUANTITY
-------------------------------------------------- */
async function changeVariant(variantId, qty, cartKey){

    console.log("changeVariant()", variantId, qty, cartKey);

    try{

        const response = await fetch('/cart/change.js',{

            method:'POST',

            headers:{
                'Content-Type':'application/json'
            },

            body:JSON.stringify({

                id: cartKey,
                quantity: qty

            })

        });

        if(!response.ok){
            throw new Error("Unable to update quantity");
        }

        await refreshAjaxCart();

        showCartToast('Quantity updated');

        await syncCartButtons();

    }

    catch(e){

        console.error(e);

    }

}

/* -------------------------------------------------
   REMOVE PRODUCT
-------------------------------------------------- */


async function removeVariant(cartKey){

    try{

        const response = await fetch('/cart/change.js',{

            method:'POST',

            headers:{
                'Content-Type':'application/json'
            },

            body:JSON.stringify({

                id: cartKey,
                quantity:0

            })

        });

        if(!response.ok){
            throw new Error("Unable to remove item");
        }

        await refreshAjaxCart();

        showCartToast('Removed from cart');

        await syncCartButtons();

    }

    catch(e){

        console.error(e);

    }

}
/* -----------------------------
   TOP RIGHT TOAST
------------------------------ */


function showCartToast(message) {


    let toast = document.getElementById("reorder-cart-toast");


    if (!toast) {


        toast = document.createElement("div");
        toast.id = "reorder-cart-toast";


        document.body.appendChild(toast);


    }
      toast.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" fill="#22c55e"/>
      <path d="M8 12.5L10.8 15L16.5 9.5"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"/>
      </svg>


      <span>${message}</span>
      `;
    toast.classList.add("show");


    clearTimeout(toast.hideTimer);


    toast.hideTimer = setTimeout(function () {
        toast.classList.remove("show");
    }, 2200);


}
async function syncCartButtons() {

    const cart = await fetch('/cart.js').then(r => r.json());

    document.querySelectorAll('.reorder-item-card').forEach(card => {

        const variantId = Number(
            card.querySelector('.reorder-add-btn').dataset.variantId
        );

        const item = cart.items.find(i => i.variant_id === variantId);

        const addBtn = card.querySelector('.reorder-add-btn');
        const qtyBox = card.querySelector('.reorder-qty-selector');

        if (item) {

            addBtn.hidden = true;
            qtyBox.hidden = false;

            qtyBox.querySelector('.reorder-qty-value').textContent =
                item.quantity;

            qtyBox.dataset.cartKey = item.key;

        } else {

            addBtn.hidden = false;
            qtyBox.hidden = true;

        }

    });

}


/* -------------------------------------------------
   REFRESH LOCAL THEME AJAX CART
-------------------------------------------------- */


async function refreshAjaxCart(){


  const response = await fetch('?section_id=helper-cart');


  const text = await response.text();


  const html = new DOMParser().parseFromString(text,'text/html');


  const cartItems = document.getElementById('AjaxCartForm');
  const newCartItems = html.getElementById('AjaxCartForm');


  if(cartItems && newCartItems){


    cartItems.innerHTML = newCartItems.innerHTML;


    if(typeof cartItems.ajaxifyCartItems === 'function'){


      cartItems.ajaxifyCartItems();


    }


  }


  const subtotal = document.getElementById('AjaxCartSubtotal');
  const newSubtotal = html.getElementById('AjaxCartSubtotal');


  if(subtotal && newSubtotal){


    subtotal.innerHTML = newSubtotal.innerHTML;


  }


  const count = cartItems?.querySelector('[data-cart-count]');


  if(count){


    document.querySelectorAll('[data-header-cart-count]').forEach(function(el){


      el.textContent = count.textContent;


    });


  }


  const total = cartItems?.querySelector('[data-cart-total]');


  if(total){


    document.querySelectorAll('[data-header-cart-total]').forEach(function(el){


      el.textContent = total.textContent;


    });


  }


}
/* -----------------------------
   START SCRIPT
------------------------------ */


if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
})();
